<h2 data-testid="action-report-client-name" [class.client-name-super]="super">{{clientNameFull}}</h2>

@if (showTip) {
<div class="tip">
  <div style="position:absolute; right:10px; bottom: 5px;">
    <a data-testid="action-report-hide-tip" (click)="hideTip()"> Thanks, I got this!</a>
  </div>
  <p>Action counts and percentages are only available when at least <strong>5</strong> users have submitted their
    actions.</p>
</div>
}



<div class="summary">

  <app-back-button (backClick)="goBack()"></app-back-button>

  <div data-testid="action-report-download" class="info" (click)="downloadReport()">
    <p class="stat">
      <img src="/assets/img/download.svg" alt="Download report icon" />
    </p>
    <p class="download-label">DOWNLOAD REPORT</p>
  </div>

</div>

<div style="display: flex; justify-content: center; padding: 20px">


  <div style="width: 100%">

    <div style="display: flex">
      <input data-testid="action-report-search" type="text" (keyup)="filter($event)" placeholder="Filter" />

      <a [hidden]="true" href="#" style="margin-left:20px;" #hiddenDownloadReport></a>

      @if (clientId == 0 ) {
      <select data-testid="action-report-type-filter" class="type-selector" (change)="selectTypeFilter($event)">
        <option value="">Select type</option>
        <option>EDUCATION</option>
        <option>FINANCE</option>
        <option>LAW</option>
        <option>OTHER</option>
      </select>
      }


      <!-- select box with academicYears as options -->
      <select data-testid="action-report-year-filter" class="type-selector" (change)="selectAcademicYear($event)">
        <option value="">Select academic year</option>
        @for (year of academicYears; track year) {
        <option [value]="year.formatted_year">{{year.formatted_year}}</option>
        }
      </select>

      @if (clientId != 0 ) {
      <select data-testid="action-report-code-filter" class="type-selector" (change)="selectCode($event)">
        <option value="">Select code</option>
        @for (code of codes; track code) {
        <option [value]="code.code">{{code.code}} - {{code.description}}</option>
        }
      </select>
      }

    </div>

    <div class="table-container">
      <mat-table id="top5Table" #avgTable [dataSource]="loading ? [] : topDataSource" matSort #avgSort="matSort">

        @for (column of topColumnNames; track column) {
        <ng-container matColumnDef="{{ column.id }}">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ column.value }}</mat-header-cell>
          <mat-cell *matCellDef="let element" [attr.data-testid]="'action-report-top-cell-' + column.id"> {{ element[column.id] }}</mat-cell>
        </ng-container>
        }


        <mat-header-row *matHeaderRowDef="topDisplayedColumns"></mat-header-row>
        <mat-row data-testid="action-report-top-row" *matRowDef="let row; columns: topDisplayedColumns"></mat-row>
      </mat-table>


      @if (loading) {
      <div class="skeleton-container">
        @for (row of skeletonRowsTop5; track $index) {
        <div class="skeleton-row-flex">
          @for (weight of row; track $index) {
          <div class="skeleton-bar dark" [style.flex-grow]="weight"></div>
          }
        </div>
        }
      </div>
      }

      @if (!loading && topDataSource.data.length == 0) {
      <div style="padding: 20px; text-align: center; color: #ccc; font-style: italic;">
        No data available
      </div>
      }
    </div>


    <div class="table-container">
      <mat-table #table [dataSource]="loading ? [] : dataSource" matSort #actionsSort="matSort">

        @for (column of columnNames; track column) {
        <ng-container matColumnDef="{{ column.id }}">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ column.value }}</mat-header-cell>
          <mat-cell *matCellDef="let element" [attr.data-testid]="'action-report-cell-' + column.id"> {{ element[column.id] }}</mat-cell>
        </ng-container>
        }


        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row data-testid="action-report-row" *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>

      @if (loading) {
      <div class="skeleton-container">
        @for (row of skeletonRows; track $index) {
        <div class="skeleton-row-flex">
          @for (weight of row; track $index) {
          <div class="skeleton-bar dark" [style.flex-grow]="weight"></div>
          }
        </div>
        }
      </div>
      }

      @if (!loading && dataSource.data.length == 0) {
      <div style="padding: 20px; text-align: center; color: #ccc; font-style: italic;">
        No data available
      </div>
      }

    </div>


    <div class="table-container">
      <mat-table id="avgTable" #avgTable [dataSource]="loading ? [] : avgDataSource" matSort #avgSort="matSort">

        @for (column of avgColumnNames; track column) {
        <ng-container matColumnDef="{{ column.id }}">
          <mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ column.value }}</mat-header-cell>
          <mat-cell *matCellDef="let element" [attr.data-testid]="'action-report-avg-cell-' + column.id"> {{ element[column.id] }}</mat-cell>
        </ng-container>
        }


        <mat-header-row *matHeaderRowDef="avgDisplayedColumns"></mat-header-row>
        <mat-row data-testid="action-report-avg-row" *matRowDef="let row; columns: avgDisplayedColumns"></mat-row>
      </mat-table>

      @if (loading) {
      <div class="skeleton-container">
        @for (row of skeletonRows; track $index) {
        <div class="skeleton-row-flex">
          @for (weight of row; track $index) {
          <div class="skeleton-bar dark" [style.flex-grow]="weight"></div>
          }
        </div>
        }
      </div>
      }

      @if (!loading && avgDataSource.data.length == 0) {
      <div style="padding: 20px; text-align: center; color: #ccc; font-style: italic;">
        No data available
      </div>
      }

    </div>

  </div>